import request from '../request'

// 是否可创建简历
export const canCreateCv = token => {
	return request({
		url: `/v3/cv_accounts/${ token }/can_create_cv`,
		method: 'get',
		data: {}
	})
}

// 获取cv template token
export const getTemplateToken = data => {
	return request({
		url: `/v3/template_cvs`,
		method: 'get',
		data: {}
	})
}

// 获取基本信息详情
export const getProfile = (cv_token, params) => {
	return request({
		url: `/v3/cvs/${ cv_token }/profile`,
		method: 'get',
		params
	})
}

// 导师获取基本信息详情
export const getMentorProfile = (cv_token, params) => {
	return request({
		url: `/v3/mentor/cvs/${ cv_token }/profile`,
		method: 'get',
		params
	})
}

// 创建基本信息
export const createProfile = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/profile`,
		method: 'post',
		data
	})
}
// 修改基本信息
export const editProfile = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/profile`,
		method: 'put',
		data
	})
}
// 修改基本信息(vip参数)
export const updateVipProfile = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/membership_profile`,
		method: 'put',
		data
	})
}

// 获取简历信息
export const getCvInfo = (token, params) => {
	return request({
		url: `/v3/cvs/${ token }`,
		method: 'get',
		params
	})
}
// 获取导师简历信息
export const getMentorCvInfo = (token, params) => {
	return request({
		url: `/v3/mentor_cvs/${ token }`,
		method: 'get',
		params
	})
}
// 更新简历信息
export const updatedCvInfo = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }`,
		method: 'put',
		data
	})
}

// 更新简历信息（vip参数）
export const updateVipMembershipInfo = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/membership_cv`,
		method: 'put',
		data
	})
}

// 导师更新简历信息
export const updatedMentorCvInfo = (cv_token, data) => {
	return request({
		url: `/v3/mentor_cvs/${ cv_token }`,
		method: 'put',
		data
	})
}

export const autoSort = (token, data, is_mentor) => {
	return request({
		url: `/v3/cvs/${ token }/auto_sort?is_mentor=${is_mentor}`,
		method: 'post',
		data
	})
}


// 简历检查
export const cvChecks = (data, params) => {
	return request({
		url: `/v3/cv_checks`,
		method: 'post',
		data,
		params
	})
}
// 简历检查-非会员
export const cvChecksLimit = (cv_token, params) => {
	return request({
		url: `/v3/cv_checks/${ cv_token }/limit`,
		method: 'get',
		params
	})
}
// 复制简历
export const duplicateCvs = (data) => {
	return request({
		url: `/v3/duplicate_cvs`,
		method: 'post',
		data
	})
}
// 删除简历
export const deleteCv = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }`,
		method: 'delete',
		data
	})
}
// 创建简历
export const createCv = (data) => {
	return request({
		url: `/v3/cvs`,
		method: 'post',
		data
	})
}


// 获取edu模块列表
export const getEdusList = (params) => {
	return request({
		url: `/v3/edus`,
		method: 'get',
		params
	})
}
// 创建教育
export const createEdu = (data) => {
	return request({
		url: `/v3/edus`,
		method: 'post',
		data
	})
}
// 编辑教育
export const editEdu = (id, data) => {
	return request({
		url: `/v3/edus/${ id }`,
		method: 'put',
		data
	})
}
// 删除教育模块
export const deleteEdu = (id, params, data) => {
	return request({
		url: `/v3/edus/${ id }`,
		method: 'delete',
		params,
		data
	})
}
//  获取教育经历是否被引用
export const edusVerify = id => {
	return request({
		url: `/v3/import/edus/${ id }`,
		method: 'get'
	})
}

// 获取work模块列表
export const getWorksList = (params) => {
	return request({
		url: `/v3/works`,
		method: 'get',
		params
	})
}
// 创建工作
export const createWork = (data) => {
	return request({
		url: `/v3/works`,
		method: 'post',
		data
	})
}
// 编辑工作
export const editWork = (id, data) => {
	return request({
		url: `/v3/works/${ id }`,
		method: 'put',
		data
	})
}
// 删除工作模块
export const deleteWork = (id, params, data) => {
	return request({
		url: `/v3/works/${ id }`,
		method: 'delete',
		params,
		data
	})
}
//  获取教育经历是否被引用
export const worksVerify = id => {
	return request({
		url: `/v3/import/works/${ id }`,
		method: 'get'
	})
}

// 获取org模块列表
export const getOrgsList = (params) => {
	return request({
		url: `/v3/orgs`,
		method: 'get',
		params
	})
}
// 创建org
export const createOrg = (data) => {
	return request({
		url: `/v3/orgs`,
		method: 'post',
		data
	})
}
// 编辑org
export const editOrg = (id, data) => {
	return request({
		url: `/v3/orgs/${ id }`,
		method: 'put',
		data
	})
}
// 删除org
export const deleteOrg = (id, params, data) => {
	return request({
		url: `/v3/orgs/${ id }`,
		method: 'delete',
		params,
		data
	})
}
//  获取org经历是否被引用
export const orgsVerify = id => {
	return request({
		url: `/v3/import/orgs/${ id }`,
		method: 'get'
	})
}

// extras模块 - other
// 获取 extras 模块 模块列表other
export const getExtras = (params) => {
	return request({
		url: `/v3/extras`,
		method: 'get',
		params
	})
}
export const getExtrasList = (params) => {
	return request({
		url: `/v3/extra`,
		method: 'get',
		params
	})
}
// 创建 extras - other
export const createExtra = (data) => {
	return request({
		url: `/v3/extras`,
		method: 'post',
		data
	})
}
// 编辑 extras - other
export const editExtra = (data) => {
	return request({
		url: `/v3/extras`,
		method: 'put',
		data
	})
}
// 删除 extras - other
export const deleteExtra = params => {
	return request({
		url: `/v3/extras`,
		method: 'delete',
		params,
	})
}

export const verifyExtra = params => {
	return request({
		url: `/v3/import/extra`,
		method: 'get',
		params,
	})
}

// 获取作品集模块列表
export const getOpusList = (params) => {
	return request({
		url: `/v3/opus`,
		method: 'get',
		params
	})
}
// 创建作品集
export const createOpus = (data) => {
	return request({
		url: `/v3/opus`,
		method: 'post',
		data
	})
}
// 编辑作品集
export const editOpus = (id, data) => {
	return request({
		url: `/v3/opus/${ id }`,
		method: 'put',
		data
	})
}
// 删除作品集模块
export const deleteOpus = (id, params, data) => {
	return request({
		url: `/v3/opus/${ id }`,
		method: 'delete',
		params,
		data
	})
}


// 获取custom模块列表
export const getCustomList = (params) => {
	return request({
		url: `/v3/custom_sections`,
		method: 'get',
		params
	})
}
export const getCustomInfoList = (id, params) => {
	return request({
		url: `/v3/custom_sections/${ id }/infos`,
		method: 'get',
		params
	})
}
export const createCustom = (data) => {
	return request({
		url: `/v3/custom_sections`,
		method: 'post',
		data
	})
}
export const createCustomInfo = (id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }/infos`,
		method: 'post',
		data
	})
}
export const editCustomTitle = (id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }`,
		method: 'put',
		data
	})
}
export const editCustomInfo = (id, info_id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }/infos/${ info_id }`,
		method: 'put',
		data
	})
}
export const deleteCustom = (id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }`,
		method: 'delete',
		data
	})
}
export const deleteCustomInfo = (id, info_id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }/infos/${ info_id }`,
		method: 'delete',
		data
	})
}
export const updateCustomTitle = (id, data) => {
	return request({
		url: `/v3/custom_sections/${ id }`,
		method: 'put',
		data
	})
}


export const customVerify = (customId, id) => {
	return request({
		url: `/v3/import/custom_sections/${ customId }/infos/${ id }`,
		method: 'get'
	})
}

// 搜索城市
export const cityAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/city_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索专业
export const majorAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/major_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索学校
export const universityAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v2/university_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索学院
export const unischoolAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/college_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索公司名称
export const companyAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/brand_company_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索职位名称
export const positionAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/job_title_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索职位名称（求职意向）
export const positionAutoCompletionsIntention = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v2/profession_auto_completions`,
		method: 'get',
		params
	})
}
// 搜索其他 技能
export const skillAutoCompletions = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/skill_auto_completions`,
		method: 'get',
		params
	})
}


// faq options
export const getFaqOptions = (params) => {
	return request({
		url: `/v3/cvs/faqs/all_items`,
		method: 'get',
		params
	})
}
export const getVerbs = (params) => {
	return request({
		url: `/v3/cvs/faqs/verbs`,
		method: 'get',
		params
	})
}
export const getExamples = (params) => {
	return request({
		url: `/v3/cvs/faqs/examples`,
		method: 'get',
		params
	})
}
export const getFaq = (params) => {
	return request({
		url: `/v3/cvs/faqs/details`,
		method: 'get',
		params
	})
}

export const getSchoolLogo = (cv_token, params) => {
	return request({
		url: `/v3/cvs/${ cv_token }/school_logo`,
		method: 'get',
		params
	})
}
export const updatedSchoolLogo = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/school_logo`,
		method: 'put',
		data
	})
}
export const deleteSchoolLogo = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/school_logo`,
		method: 'delete',
		data
	})
}
// 导师辅导提交评价
export const mentorUpdateRate = data => {
	return request({
		url: '/v3/comments/update_rate',
		method: 'put',
		data
	})
}
// 导师辅导获取问题 回答
export const mentorComments = (cv_token, data) => {
	return request({
		url: `/v3/comments/cv_index/${ cv_token }`,
		method: 'get',
		data: {}
	})
}
// 导师辅导提问
export const createTaskComment = (cv_token, data) => {
	return request({
		url: `/v3/comments/cv_index/${ cv_token }`,
		method: 'post',
		data
	})
}
// 导师辅导状态更改
export const updateTaskState = data => {
	return request({
		url: `/v3/comments/update_task`,
		method: 'put',
		data
	})
}

// 获取分享简历html
export const getCvHtml = (cv_token, params) => {
	return request({
		url: `/v3/share_cvs/${ cv_token }/html`,
		method: 'get',
		params
	})
}

// 获取简历命名part
export const getCvNamePart = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/name_part_options`,
		method: 'get',
		data: {}
	})
}

// 下载简历
export const downloadCv = (cv_token, params) => {
	return request({
		url: `/v3/cvs/${ cv_token }/download_url`,
		method: 'get',
		params
	})
}

// 下载图片简历
export const downloadCvImg = (cv_token, params) => {
	return request({
		url: `/v3/cvs/${ cv_token }/img_download_url`,
		method: 'get',
		params
	})
}

// 下载合并中英文简历
export const downloadCombinedCv = (cv_token, data) => {
	return request({
		url: `/v3/cvs/${ cv_token }/combine_cv_download_url`,
		method: 'post',
		data
	})
}

// 预测草稿简历
export const getCvPredictedResult = (cv_token) => {
	return request({
		url: `/v3/intelligent_cvs/${ cv_token }/job_infos`,
		method: 'get',
	})
}

// 分享简历发送邮箱
export const sendCvEmail = (cv_token, email, params) => {
	return request({
		url: `/v3/sharing_cvs/${ cv_token }?recipient_email=${ email }&type=email`,
		method: 'get',
		params
	})
}

// 翻译简历
export const translateCv = (data) => {
	return request({
		url: `/v3/translate_cvs`,
		method: 'post',
		data
	})
}

// 分享简历获取小程序码
export const cvQr = (data, token) => {
	return request({
		url: `/v3/cvs/${ token }/miniprogram_qr?file_type=cv`,
		method: 'get',
		data
	})
}

// 校验是否可以翻译简历
export const verifyCanTransCv = (token, params) => {
	return request({
		url: `/v3/cv_accounts/${ token }/can_trans_cv`,
		method: 'get',
		params
	})
}
// 获取动词，案例，小贴士
export const getAssistInfo = params => {
	return request({
		url: `/v3/cvs/faqs/submodule_all_items`,
		method: 'get',
		params
	})
}
// 中文简历-工作经历-贴士等下拉框接口
export const getWorkExamples = (token, params) => {
	return request({
		url: `/v3/cvs/${ token }/work_examples`,
		method: 'get',
		params
	});
}
// 获取同时在线人数
export const getOnlineUserCount = () => {
	return request({
		url: '/v3/cvs/online_user_count',
		method: 'get',
		params: {}
	})
}
// 切换editor编辑主题
export const changeEditorTheme = (token, data) => {
	return request({
		url: `/v3/cv_accounts/${ token }/cv_theme`,
		method: 'put',
		data
	})
}

// 根据职位名称去获取职位的的级别id
export const getPostLevelId = (data) => {
	return request({
		url: `/v3/jobs/job_levels`,
		method: 'POST',
		data
	})
}
// 根据关键字和职位的级别id获取自动写简历的内容
export const getAutoWriteList = (data) => {
	return request({
		url: `/v3/works/writer`,
		method: 'POST',
		data
	})
}

// 获取动词名词列表
export const getRecommendWords = (data) => {
	return request({
		url: `/v3/works/writer/recommend_words`,
		method: 'POST',
		data
	})
}

// 自动写工作经历
export const getAutoWritingList = (data) => {
	return request({
		url: `/v4/works/writer`,
		method: 'POST',
		data
	})
}

// 判断是不是第一份简历
export const getIsFirstCv = params => {
	return request({
		url: `/v3/first_cvs`,
		method: 'GET',
		params
	})
}

// 判断模块是否超过30条
export const isModelOverMore30 = (params) => {
	return request({
		url: `/v3/cv_accounts/module_checks`,
		method: 'GET',
		params
	})
}